import { Pipe, PipeTransform } from '@angular/core';
import {ETransferType} from '../enums/ETransferType';
import {environment} from '../../environments/environment';

@Pipe({
  name: 'filterTransferType'
})
export class FilterTransferTypePipe implements PipeTransform {

  productName = environment.productName;

  transform(transferType: string): string {
    switch (transferType) {
      case ETransferType.INTERNAL:
        return $localize `:@@transfers_sameBankAccount: Card to card`;
      case ETransferType.INTERNATIONAL:
        return $localize `:@@transfers_mexicanBankAccount: Cuenta mexicana`;
      default:
        return status.toString();
    }
  }

}
